module.exports = __webpack_public_path__ + "img/组 362 拷贝 2.ce61601d.png";